import { Injectable, NgZone } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AlertDialogComponent, ErrorDialogData } from '../alert-dialog.component';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { AlertToastDialogComponent } from '@shared/components/alert-toast-dialog/alert-toast-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AlertDialogService {

  constructor(private _matDialog: MatDialog, private _snackBar: MatSnackBar, private _ngZone: NgZone) { }

  fnMostrarAlertModal(data: ErrorDialogData): void {
    const dialogConfig = {
      data: data,
      disableClose: true,
      panelClass: 'app-custom-dialog',
      backdropClass: 'custom-backdrop',
    };

    this._matDialog.open(AlertDialogComponent, dialogConfig);
  }

  fnMostrarToastAlert(data: ErrorDialogData, duration: number = 8000): void {
    const toastConfig: MatDialogConfig = {
      data: data,
      disableClose: false,
      hasBackdrop: false,
      panelClass: ['app-toast-dialog', data.iconType],
      width: '320px',
      height: 'auto',
      position: {
        top: '20px',
        right: '130px'
      }
    };

    const dialogRef = this._matDialog.open(AlertDialogComponent, toastConfig);

    this._ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this._ngZone.run(() => {
          dialogRef.close();
        });
      }, duration);
    });
  }

  fnMostrarToastAlertMD(data: ErrorDialogData, duration: number = 10000): void {
  const toastConfig: MatSnackBarConfig = {
    duration: duration,
    horizontalPosition: 'end',
    verticalPosition: 'top',
    panelClass: ['app-toast-snackbar', data.iconType],
    data: data
  };

  this._snackBar.openFromComponent(AlertToastDialogComponent, toastConfig);
}
}
